<template>
  <div class="mailbox-verification-instructions-no-provider">
    <h3>Setting up auto-forwarding with your email provider</h3>
    <p>
      Follow the steps below to get auto-forwarding set up with your email provider. If you still
      aren't able to get things working, just
      <a href="https://www.donedone.com/help-center" target="_blank" class="just-a-link">reach out to us</a> for help!
    </p>
    <div class="step">
      <span>1</span>
      <p>
        Do an internet search for your email provider. Include <strong>"set up auto-forwarding"</strong> in your query.
      </p>
    </div>
    <div class="step">
      <span>2</span>
      <p>
        Look for instructions from your on how to auto-forward or redirect emails to a specific email address.
        If you're having trouble, <a href="https://www.donedone.com/help-center" target="_blank" class="just-a-link">contact us for help</a>.
      </p>
    </div>
    <div class="step">
      <span>3</span>
      <div>
        <p>
          <strong>When asked to enter the address to forward emails to</strong>, copy and paste this address:
        </p>
        <clipboard-text :text="incomingEmailAddress" class="incoming-email-address" />
      </div>
    </div>
    <div class="step">
      <span>4</span>
      <div>
        <p>
          Some email providers will send a confirmation email to the address to confirm you have access to it. If this is the case
          for you, click below so we can check for that email.
        </p>
        <p><br></p>
        <dd-button type="flat" full-width @click="showVerificationPopup=true">Check for a confirmation email from your provider</dd-button>
      </div>
    </div>
    <div class="step">
      <span>5</span>
      <p>
        Complete any remaining steps from your provider.
      </p>
    </div>
    <p><br></p>
    <dd-button
      :color="ColorAssistant.MailboxColor"
      size="large"
      full-width
      @click="$emit('completion-clicked')"
    >I've done all these steps. Verify auto-forwarding is working!</dd-button>
    <mailbox-verification-popup-email-viewer v-if="showVerificationPopup" v-model:show-modal="showVerificationPopup" />
  </div>
</template>
<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */
import MailboxVerificationPopupEmailViewer from '../components/mailbox-verification-popup-email-viewer.vue'

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */

/* API */

export default defineComponent({
  name: 'MailboxVerificationInstructionsNoProvider',
  components: {
    MailboxVerificationPopupEmailViewer,
  },
  props: {
    incomingEmailAddress: {
      type: String,
      required: true,
    },
    forwardingFromAddress: {
      type: String,
      required: true,
    },
  },
  emits: ['completion-clicked'],
  data() {
    return {
      ColorAssistant,
      showVerificationPopup: false,
    }
  },
})
</script>

<style lang="scss">
.mailbox-verification-instructions-no-provider {
  .step {
    display: flex;
    padding-top: 24px;
    &:last-of-type {
      padding-bottom: 20px;
    }
    > div {
      width: 100%;
    }
    .check-for-email-btn {
      margin-top: 10px;
    }
    /* Step number */
    > span {
      border-radius: 50%;
      border: solid 1px $mailboxes--theme-color;
      color: $mailboxes--theme-color;
      width: 24px;
      height: 24px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
    }
  }
}
</style>
